export const KEY = "canvas_redirect_loop_guard";
const DEFAULT_LOOP_THRESHOLD = 10 * 1000; // 10 Seconds

/**
 * Function to redirect to an external URL and
 * guard against redirect loops
 */
export const redirectWithLoopGuard = (
  url,
  { loopThreshold = DEFAULT_LOOP_THRESHOLD } = {}
) => {
  const serializedData = localStorage.getItem(KEY);
  const data = serializedData && JSON.parse(serializedData);
  const msSinceLastRedirect = Date.now() - (data?.[url] ?? 0);

  if (msSinceLastRedirect < loopThreshold) {
    throw new Error("Possible redirect loop");
  }

  localStorage.setItem(KEY, JSON.stringify({ ...data, [url]: Date.now() }));
  window.location.replace(url);
};
